import { Injectable, inject } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { DataMartTable } from '@r1-compass-library/models';
import { DataMartService } from '@r1-compass-library/services';
import { exhaustMap, Observable } from 'rxjs';

export interface DataMartLifecyclesTableState {
    tables: DataMartTable[] | undefined;
}

const initialState: DataMartLifecyclesTableState = {
    tables: [],
};
@Injectable({
    providedIn: 'root',
})
export class DataMartLifecyclesTableStore extends ComponentStore<DataMartLifecyclesTableState> {
    readonly #dataMartService = inject(DataMartService);

    tables$ = this.select(state => state.tables);
    tables = this.selectSignal(state => state.tables);

    constructor() {
        super(initialState);
    }

    setTables = this.updater((state, tables: DataMartTable[]) => ({
        ...state,
        tables: tables,
    }));
    getTables = this.effect((trigger$: Observable<void>) => {
        return trigger$.pipe(
            exhaustMap(trigger => {
                return this.#dataMartService.getLifecycleDataModel().pipe(
                    tapResponse({
                        next: dataModel => {
                            this.setTables(dataModel?.tables ?? []);
                        },
                        error: err => {
                            console.error(err);
                            //clear out what was there so we don't have stale data
                            this.setTables([]);
                        },
                    })
                );
            })
        );
    });
}
